import React from 'react';
import { useController } from 'react-hook-form';
import { SignupFormData } from 'features/signUp/types';
import { PrivacyPolicy } from 'components/PrivacyPolicy/PrivacyPolicy';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

interface PrivacyPolicyAcceptanceStepProps {
  privacyPolicyUrl: string;
  eulaPolicyUrl: string;
}

export const PrivacyPolicyAcceptanceStep = ({
  privacyPolicyUrl,
  eulaPolicyUrl,
}: PrivacyPolicyAcceptanceStepProps) => {
  const { translation } = useTranslationContext();
  const privacyPolicyAcceptanceState = useController<SignupFormData>({
    name: 'privacyPolicyAccepted',
  });
  const eulaPolicyAcceptanceState = useController<SignupFormData>({
    name: 'eulaPolicyAccepted',
  });

  return (
    <PrivacyPolicy
      title={translation('privacy_policy_and_eula_header')}
      privacyPolicyUrl={privacyPolicyUrl}
      eulaPolicyUrl={eulaPolicyUrl}
      privacyPolicyAcceptanceStateFieldProps={privacyPolicyAcceptanceState.field}
      eulaPolicyAcceptanceStateFieldProps={eulaPolicyAcceptanceState.field}
    />
  );
};
